@if(mode === ModeType.Edit) {
  <ng-template appDialogTitleRowExtraContent>
    <button
      mat-icon-button
      matTooltip="Delete annotation"
      (click)="_deleteAnnotation()"
      class="button-adjustment"
      >
      <ion-icon name="trash-outline" />
    </button>
  </ng-template>
}


<!-- Main content -->
<!-- 'XYZ-in-progress'-indicator -->
@if (isWorking) {
  <app-loading-overlay [targetElement]="contentEl">
    <app-spinner size="lg" />
  </app-loading-overlay>
}

<div #contentEl class="m-0 !p-0 flex flex-auto">

  <div class="flex-auto grid grid-rows-1 grid-cols-[1fr_1px_1fr] gap-4 overflow-hidden">

    <!-- annotation main data (e.g. description)-->
    <div class="col-1 row-1 min-w-[388px] flex flex-col gap-1 overflow-hidden">
      <!-- Date & Time -->
      <div>
        <mat-label>Date and time</mat-label>
        <app-date-time-picker 
          required
          [formControl]="dateControl"
          [isHoverEventsPluginEnabled]="true"
          [dateClassesToApply]="dateTimePickerDateClasses()"
          (dayElementHoverIn)="dateTimePickerHoverIn($event)"
          (dayElementHoverOut)="dateTimePickerHoverOut($event)" />
      </div>

      <!--
      Depending on mode
      - `add` or `duplicate` => object/replicate selector (differing labels only)
      - `edit`: nothing
      -->
      @if(mode === ModeType.Create || mode === ModeType.Duplicate) {
        <mat-form-field>
          <!-- Label (depending on mode) for replicate selection -->
          <mat-label>
            @if(mode === ModeType.Create) {
              Add annotation to
            }
            @else {
            Duplicate annotation to
          }
        </mat-label>

        <!-- 
          The object/replicate selection dropdown 
        -->
        <mat-select
          multiple
          [value]="selectedThingies"
          (selectionChange)="_replicateSelectionChange($event)"
          placeholder="Select replicates"
          [disabled]="possibleThingies.length <= 1"
          matTooltip="No other replicates available"
          [matTooltipDisabled]="possibleThingies.length > 1"
        >
          <mat-select-trigger>
            @if(selectedThingies.length === 1 && selectedThingies[0] !== 'all') {
              @if(_defaultThingie && selectedThingies[0] === _defaultThingie) {
                <i>{{ selectedThingies[0].name }}</i>
              } @else {
                {{ selectedThingies[0].name }}
              }
            }
            @else {
              @if(numberOfReplicatesSelected === 0) {
                Select replicates
              }
              @else {
                @if(selectedThingies[0] === 'all') {
                  All replicates selected
                }
                @else {
                  {{ numberOfReplicatesSelected }} replicate{{ numberOfReplicatesSelected === 1 ? '' : 's' }} selected
                }
              }
            }
          </mat-select-trigger>

      <mat-option value="all">
        All replicates
      </mat-option>

      @for(target of possibleThingies; track target._id!) {
        <!-- Except from Duplication-Mode, the default Thingie should not be de-selectable -->
        <mat-option [value]="target" class="pl-[30px]">
          @if(_defaultThingie && target === _defaultThingie) {
            <i>{{ target.name }}  (current replicate)</i>
          } @else {
            {{ target.name }}
          }
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}


<!-- Comment -->
<div class="flex-auto overflow-x-hidden overflow-y-auto">
  <mat-form-field class="w-full">
    <mat-label>Comment</mat-label>
    <textarea
      matInput
      appAutoFocus
      placeholder="Enter comment..."
      required
      [formControl]="commentFormControl"
      rows="15"
      data-cy="annotation_handling_dialog__comment"
      >
    </textarea>
  </mat-form-field>
</div>

</div>

<!-- Vertical separator line -->
<div class="col-2 row-1 vertical-separator"></div>

<!-- attachments -->
<div class="col-3 row-1 min-h-0 flex flex-col">
  <app-annotation-attachment-manager
    [annotation]="annotation"
    [canAddAttachments]="true"
    (annotationAttachmentUpdated)="_annotationAttachmentUpdated()"
    [mode]="'edit'"
    class="flex flex-col overflow-hidden"
    >
  </app-annotation-attachment-manager>
</div>

</div>

</div>

<!-- Footer/button row -->
<ng-template #dialogButtons>
  <button
    mat-stroked-button
    (click)="closeDialog()"
  >
    Cancel
  </button>
  @let formHasError = dateControl.invalid || commentFormControl.invalid;
  @let attachmentIsChanged = formHasError === false && annotationAttachmentUpdated() === true;
  @let formIsPristine = formHasError === false && dateControl.pristine === true && commentFormControl.pristine === true && attachmentIsChanged === false;

  <button
    mat-flat-button
    color="primary"
    [disabled]="isWorking 
      || formHasError === true
      || formIsPristine === true
      || (selectedThingies.length === 0 && mode !== ModeType.Edit)
    "
    (appButtonClick)="$event.waitFor(_save())"
    data-cy="annotation_handling_dialog__save_button"
  >
    Save
  </button>
</ng-template>
